import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../layout/Header';
import AdminSidebar from './AdminSidebar';
import './AdminLayout.css';

const AdminLayout = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="admin-layout">
      <Header />
      <div className="admin-layout__container">
        <AdminSidebar isMobileOpen={isMobileMenuOpen} onClose={closeMobileMenu} />
        <main className="admin-layout__main">
          <div className="admin-layout__content">
            {!isMobileMenuOpen && (
              <button 
                className="admin-layout__mobile-toggle admin-sidebar__toggle"
                onClick={toggleMobileMenu}
                aria-label="Toggle menu"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="3" y1="6" x2="21" y2="6"></line>
                  <line x1="3" y1="12" x2="21" y2="12"></line>
                  <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
              </button>
            )}
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;